import React from 'react';
import PropTypes from 'utils/propTypes';
import classNames from 'classnames';
import { Card, CardTitle, CardSubtitle, CardBody } from 'reactstrap';
import { MdFace } from 'react-icons/md';
import JWTProvider from 'apiservices/JWTProvider';

const UserCard = ({
  avatar,
  avatarSize,
  title,
  subtitle,
  text,
  children,
  className,
  ...restProps
}) => {
  const classes = classNames('bg-gradient-theme', className);
  const username = JWTProvider.GetUsername();

  return (
    <Card inverse className={classes} {...restProps}>
      <CardBody className="d-flex justify-content-center align-items-center flex-column">
        <MdFace style={{ fontSize: "50px" }} />
        <CardTitle></CardTitle>
        <CardSubtitle>{username}</CardSubtitle>
      </CardBody>
      {children}
    </Card>
  );
};

UserCard.propTypes = {
  avatar: PropTypes.string,
  avatarSize: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
};

UserCard.defaultProps = {
  avatarSize: 80,
};

export default UserCard;
